import React, { Component } from "react";
import { Button } from "@blueprintjs/core";
import { Spinner } from "@blueprintjs/core"
import PMTGSTask from "./PMTGSTask";
import { DropTarget } from 'react-dnd';
import { TASK_STATUS, TASK_STATUS_COLOR, PMDNDTypes } from "../../constants";
import IconSmallButton from "../../../blueprintWrappers/IconSmallButton";

class PMTaskGroup extends Component {

	loading = () => {
		return <div style={{ textAlign: 'center' }}>
			<Spinner />
		</div>;
	}

	render() {
		const p = this.props;
		return (
			p.connectDropTarget(
				<div className={"PMTaskGroup" + (p.hovered === true ? " PMHover" : "")}>

					<div className={"PMTaskGroupHeader"}>
						<div className={"PMTaskGroupHeaderLeft"}>
							<div>
								<h2 >
									{p.columnTitle}
									<IconSmallButton
										iconName="edit"
										title="Edit Task"
										onClick={() => p.selectEditTaskGroup(p.taskGroup)}
									/>
								</h2>
							</div>
						</div>
						<div className={"PMTaskGroupHeaderRight"}>

							<Button
								icon="plus"
								title="New Task"
								intent="success"
								onClick={() => p.addNewTask(p.taskGroup)}
							>
								Task
							</Button>
						</div>
					</div>

					<div className={"PMTaskGroupLine"}></div>

					<div className={"PMTaskGroupDetails"}>
						<div className={"PMTaskGroupDetail"}>
							{p.taskGroup.description}
						</div>
						{this.props.taskGroup.tasks !== null ? this.hours() : null}
						{this.props.taskGroup.tasks !== null ? this.billing() : null}
					</div>

					<div className={"PMTaskGroupLine"}></div>

					{p.isLoading === true ? this.loading() : this.list()}
				</div >
			)
		);
	}

	hours = () => {
		let filt = this.props.tasks.filter(this.isChildOfTaskGroup);
		return (
			<div className={"PMTaskGroupDetail"}>
				Hours worked / planned: <b>{calcHoursWorked(filt)} / {calcHoursPlanned(filt)}</b>
			</div>
		)

		function calcHoursWorked(tasks) {
			let total = 0;
			for (let task of tasks) {
				for (let hl of task.hourLines) {
					total += parseFloat(hl.hours);
				}
			}
			return total;
		}

		function calcHoursPlanned(tasks) {
			let total = 0;
			for (let task of tasks) {
				for (let hl of task.hourLines) {
					total += parseFloat(hl.planned);
				}
			}
			return total;
		}

	}

	billingPermission = () => { // TODO1
		const { currentUserRole } = this.props;
		if (currentUserRole != 'Dev')
			return true;
		else
			return false;
	}

	billing = () => {
		let filt = this.props.tasks.filter(this.isChildOfTaskGroup);

		if (!this.billingPermission()) {
			return null
		}

		return (
			<div className={"PMTaskGroupDetail"}>
				Hours billable: <b>{calcHoursBilled(filt)} / {calcHoursBillable(filt)}</b>
			</div>
		)

		function calcHoursBilled(tasks) {
			let total = 0;
			for (let task of tasks) {
				for (let hl of task.hourLines) {
					total += parseFloat(hl.billed);
				}
			}
			return total;
		}

		function calcHoursBillable(tasks) {
			let total = 0;
			for (let task of tasks) {
				for (let hl of task.hourLines) {
					total += parseFloat(hl.billable);
				}
			}
			return total;
		}

	}

	isChildOfTaskGroup = (t) => {
		let result = false;
		if (this.props.taskGroup.tasks.includes(t.uniqueID)) {
			result = true;
		}
		return result;
	}

	list = () => {
		const p = this.props;
		if (this.props.taskGroup.tasks !== null) {
			return p.tasks.map((task, i) => {
				if (task.parentID === p.taskGroup.uniqueID) {
					return <PMTGSTask
						color={TASK_STATUS_COLOR[task.status]}
						task={task}
						selectEditTask={p.selectEditTask}
						index={i}
						colIndex={p.colIndex}
						key={task.uniqueID + '_' + i}
					/>
				} else {
					return null
				}
			});

		}
	};


}

const dropSource = {
	drop: function (props, monitor, component) {
		const item = monitor.getItem();
		//console.log(item.task); // dragging
		//console.log(component); //drop target
		//console.log(monitor);

		//if (monitor.isOver()) {
		//	console.log("monitor.isOver");
		//}

		if (item.colIndex !== component.props.colIndex) {
			component.props.moveTask(
				item.task,
				component.props.taskGroup
			);
		}

		const started = monitor.getInitialClientOffset();
		const sub = monitor.getInitialSourceClientOffset();
		const delta = monitor.getDifferenceFromInitialOffset();
		const calc_x = delta.x + (sub.x);
		const calc_y = delta.y + (sub.y);
	},

}

function dropCollect(connect, monitor) {
	//console.log("dropCollect");
	return {
		connectDropTarget: connect.dropTarget(),
		hovered: monitor.isOver({ shallow: true })
	}
}

export default DropTarget(PMDNDTypes.WINDOW, dropSource, dropCollect)(PMTaskGroup);



// WEBPACK FOOTER //
// ./src/components/projectmanager/new/TaskGroup/PMTaskGroup.js